import WrappingFloatingInspector from './WrappingFloatingInspector'

function WrappingFloatingInspectorCyanPurple({rounded, style, children}) {
  return (
    <WrappingFloatingInspector rounded={rounded} style={{ ...style, boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.08), 0px 0px 10px rgba(2, 252, 255, 0.50), 0px 4px 10px rgba(244, 9, 255, 0.40)',}}>{children}</WrappingFloatingInspector>
  )
}

export default WrappingFloatingInspectorCyanPurple